import { defineDocStore } from '@/stores/base/baseDocStore'
import { FilterMatchMode } from '@primevue/core/api'
import { type Comment } from '@/types/Comment'
import { CommentModel } from '@/models/CommentModel'

// Define default filters and sort order
export const defaultFilters = {
  global: { value: null, matchMode: FilterMatchMode.CONTAINS },
  content: { value: null, matchMode: FilterMatchMode.CONTAINS },
  createdAt: { value: null, matchMode: FilterMatchMode.EQUALS },
  createdBy: { value: null, matchMode: FilterMatchMode.EQUALS },
}

export const defaultSort = {
  field: 'createdAt',
  order: -1,
}

// Create the comment store using the base document store
export const useCommentStore = defineDocStore<Comment>({
  entityName: 'comment',
  collection: 'comments',
  model: CommentModel,
  initialState: {
    filters: defaultFilters,
    sort: defaultSort,
  },
})

// Re-export Comment type for convenience
export type { Comment } from '@/types/Comment'
